






























import { Component, Prop, Emit, Vue } from "vue-property-decorator";
@Component
export default class ButtonComponent extends Vue {
  @Prop({
    default: "ボタン"
  })
  msg!: string;
  @Prop({
    default: "50px"
  })
  width!: string;
  @Prop({
    default: "50px"
  })
  height!: string;
  @Prop({
    default: "theme-1"
  })
  color!: string;
  @Prop({
    default: "4px"
  })
  borderRadius!: string;
  @Prop({
    default: ""
  })
  link!: string;
  @Prop({
    default: false
  })
  disabled?: boolean;
  @Prop({
    default: null
  })
  queries?: { [s: string]: any } | null;

  @Emit()
  click(event: MouseEvent) {
    return event;
  }
}
